"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuery = getQuery;
function getQuery(name) {
  var m = null;
  var _window = window,
    location = _window.location;
  if (location !== null && location !== void 0 && location.search) {
    m = location.search.match(new RegExp("(\\?|&)".concat(name, "=([^&]*)(#|&|$)")));
  }
  return !m ? '' : decodeURIComponent(m[2]);
}